import React, {FC} from "react";
import {useHistory, useParams, useRouteMatch} from "react-router-dom";
import {useOrder} from "../../redux/orders.hook";
import {Button, Grid, makeStyles, Typography} from "@material-ui/core";
import {ClientProfileCard} from "../../../clients/screens/ClientProfileCard";
import {useClient} from "../../../clients/redux/clients.hook";
import {OrderHeadline} from "./OrderHeadline";
import {OrderCard} from "./OrderCard";
import {Alert, AlertTitle} from "@material-ui/lab";
import {formatDate} from "../../../../date.utils";
import {CancelOrderDialog} from "../../sharedComponents/CancelOrderDialog";
import {isBefore, subDays} from "date-fns";

const useStyles = makeStyles((theme) => ({
    card: {
        height: "100%"
    },
    cancelOrderButton: {
        marginTop: theme.spacing(3),
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText
    }
}));

export const OrderScreen: FC = () => {
    const classes = useStyles();
    const {url} = useRouteMatch();
    const history = useHistory();

    const {id} = useParams<{ id: string }>();
    const {order} = useOrder(id);
    const {client} = useClient(order?.clientId);

    const isMoreThanTwoDaysBefore = order && isBefore(new Date(), subDays(order.estimatedFrom, 2));

    const navigateToCancelOrder = () => history.replace(`${url}?mode=edit#cancel-order`);

    return (
        <React.Fragment>
            <OrderHeadline
                order={order}
                client={client}
            />
            {order && <CancelOrderDialog order={order} type="admin"/>}
            {order?.cancellation &&
            <Alert severity="error" style={{marginBottom: 16}}>
                <AlertTitle>Abgesagt am {formatDate(order.cancellation.canceledAt)}</AlertTitle>
                <b>Grund:</b> <Typography variant="inherit">{order.cancellation.reason}</Typography>
            </Alert>}
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <ClientProfileCard client={client} cardProps={{className: classes.card}}/>
                </Grid>
                <Grid item xs={6}>
                    <OrderCard order={order} cardProps={{className: classes.card}}/>
                </Grid>
            </Grid>
            {isMoreThanTwoDaysBefore && !order?.cancellation &&
            <Button
                variant="contained"
                onClick={navigateToCancelOrder}
                className={classes.cancelOrderButton}
            >
                Absagen
            </Button>}
        </React.Fragment>
    )
}
